import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLoginMutation } from "../features/auth/authApi";
import Logo from "./../assets/images/logo.png";
import { RiLockPasswordLine } from "react-icons/ri";

export default function Login() {
    // login api
    const [login, { data, isLoading, isError, error }] = useLoginMutation();
    const navigate = useNavigate();

    // stored form inputs data
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    // login submit handler
    const loginSubmit = (e) => {
        e.preventDefault();
        if (!isLoading && !isError) {
            login({
                email,
                password,
            });
        }
    };

    // checking is a user is logged & if data exist on api
    useEffect(() => {
        if (!isLoading && !isError) {
            if (data?.accessToken && data?.user) {
                navigate("/teams");
            }
        }
    }, [isLoading, isError, navigate, data?.accessToken, data?.user]);

    // reset inputs of state
    const clear = () => {
        setEmail("");
        setPassword("");
    };

    return (
        <>
            <div className="grid place-items-center h-screen bg-[#F9FAFB">
                <div className="min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
                    <div className="max-w-md w-full space-y-8">
                        <div>
                            <img
                                className="mx-auto h-12 w-auto"
                                src={Logo}
                                alt="Learn with sumit"
                            />
                            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                                Sign in to your account
                            </h2>
                        </div>
                        <form
                            onSubmit={loginSubmit}
                            className="mt-8 space-y-6"
                            method="POST"
                        >
                            <input type="hidden" name="remember" value="true" />
                            <div className="rounded-md shadow-sm -space-y-px">
                                <div>
                                    <label
                                        htmlFor="email-address"
                                        className="sr-only"
                                    >
                                        Email address
                                    </label>
                                    <input
                                        id="email-address"
                                        name="email"
                                        type="email"
                                        required
                                        className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                                        placeholder="Email address"
                                        value={email}
                                        onChange={(e) =>
                                            setEmail(e.target.value)
                                        }
                                    />
                                </div>
                                <div>
                                    <label
                                        htmlFor="password"
                                        className="sr-only"
                                    >
                                        Password
                                    </label>
                                    <input
                                        id="password"
                                        name="password"
                                        type="password"
                                        required
                                        className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                                        placeholder="Password"
                                        value={password}
                                        onChange={(e) =>
                                            setPassword(e.target.value)
                                        }
                                    />
                                </div>
                            </div>

                            <div>
                                <button
                                    type="submit"
                                    className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
                                >
                                    Sign in
                                </button>
                            </div>
                        </form>
                        <div className="p-6 shadow-lg rounded">
                            <h4 className="text-lg font-bold mb-3 text-green-500">
                                Registered User:
                            </h4>
                            <ul className="flex flex-col gap-2 list-disc">
                                <li className="flex items-center text-gray-800 gap-2">
                                    1, haider@gmail.com
                                </li>
                                <li className="flex items-center text-gray-800 gap-2">
                                    2, hira@gmail.com
                                </li>
                                <li className="flex items-center text-gray-800 gap-2">
                                    3, monir@gmail.com
                                </li>
                                <li className="flex items-center text-gray-800 gap-2">
                                    4, tarek@gmail.com
                                </li>
                            </ul>
                            <p className="mt-4 flex items-center gap-2">
                                <RiLockPasswordLine className="text-lg text-red-700" />{" "}
                                1234
                            </p>
                        </div>

                        {isError && (
                            <div
                                className="p-2 w-full rounded-full bg-red-800 items-center text-indigo-100 leading-none lg:rounded-full flex lg:inline-flex"
                                role="alert"
                            >
                                <span className="flex rounded-full bg-red-500 uppercase px-2 py-1 text-xs font-bold mr-3">
                                    Login Error
                                </span>
                                <span className="font-semibold mr-2 text-left flex-auto">
                                    {error?.status === 400 && error?.data}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
